export default __webpack_public_path__ + "static/media/keto_cholesterol@2x.5b359c90.jpg";